import styled from 'styled-components';

import colors from '../../assets/colors';
import { Typography } from '../../shared/typography';
import { AppStatusEnum } from '../../store/Applications/reducer';

interface IProp {
	isScrolled?: boolean;
}

const Wrapper = styled.div`
	padding: 0 40px;
`;

const FixedTitle = styled.div<IProp>`
	position: sticky;
	top: 0;
	z-index: 3;
	overflow: hidden;
`;

const Title = styled(Typography)`
	font-size: 52px;
	line-height: 62px;
	font-weight: 600;
`;

const Content = styled.div`
	display: flex;
	gap: 10px;
	flex-wrap: wrap;
`;

const Box = styled.div<{ width: number }>`
	position: relative;
	background-color: ${p => p.theme.colors.white};
	box-shadow: 0px 2px 2px rgba(33, 33, 30, 0.1);
	border-radius: 20px;
	height: ${props =>
		props.width <= 1520 && props.width >= 1400
			? '260px'
			: props.width <= 1400 && props.width >= 1300
			? '240px'
			: props.width <= 1300 && props.width >= 1200
			? '230px'
			: props.width <= 1200 && props.width >= 1100
			? '210px'
			: props.width <= 1100
			? '210px'
			: '285px'};
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-end;
	align-self: flex-start;
	margin-bottom: 20px;
	padding: ${props =>
		props.width <= 1520 && props.width >= 1400 ? '20px' : '24px'};
`;

const statusSize = 12;
const Status = styled.div<{ status: AppStatusEnum }>`
	background-color: ${p =>
		p.status === AppStatusEnum.ACTIVE
			? p.theme.colors.green
			: p.status === AppStatusEnum.PENDING
			? p.theme.colors.yellow
			: p.theme.colors.white};
	position: absolute;
	top: 24px;
	right: 24px;
	width: ${statusSize}px;
	height: ${statusSize}px;
	border-radius: ${statusSize / 2}px;
`;

const Footer = styled.div`
	padding: 50px 0 0;
	display: flex;
	gap: 20px;
	align-items: flex-start;
	margin: 0 -10px 100px -10px;
`;

const ColorBox = styled.div<{ color: keyof typeof colors }>`
	background-color: ${p => p.theme.colors[p.color]};
	display: flex;
	align-items: stretch;
	justify-content: space-between;
	flex-wrap: wrap;
	max-width: 570px;
	width: 100%;
	border-radius: 20px;
	box-shadow: 0px 2px 2px rgba(33, 33, 30, 0.1);
	padding: 24px;
	height: 270px;
`;

const LeftSide = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	max-width: 305px;
`;

const RightSide = styled.div`
	display: flex;
	align-items: flex-end;
`;

const ColorBtn = styled.button<{
	color: keyof typeof colors;
}>`
	background-color: ${p => p.theme.colors[p.color]};
	width: 185px;
	height: 43px;
	border-radius: 20px;
`;

const ModalContent = styled.div`
	display: flex;
	height: 100%;
	padding: 0 40px 30px;
	align-items: center;
	flex-direction: column;
	justify-content: flex-end;
`;

const Shadow = styled.div<IProp>`
	background-color: ${p => p.theme.colors.bgrdGrey};
	box-shadow: ${props =>
		props.isScrolled ? '0px 2px 20px rgba(33, 33, 30, 0.2)' : 'none'};
	padding: 20px 40px;
`;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
	Wrapper,
	Title,
	Shadow,
	Content,
	Box,
	Status,
	Footer,
	ColorBox,
	FixedTitle,
	LeftSide,
	RightSide,
	ColorBtn,
	ModalContent,
};
